import {
    UseQueryOptions,
    // UseInfiniteQueryOptions,
    // InvalidateQueryFilters,
    // InvalidateOptions,
    // SetDataOptions,
    // InfiniteData,
    // useQueryClient,
    // useInfiniteQuery,
    useQuery,
    // useMutation,
} from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { ICatalogItem } from 'interfaces'
import { TStoreCategoriesProps } from 'services/StoreService'
import { StoreService } from 'services'
import * as userSelectors from 'containers/User/user-selectors'
import { getRequestError } from 'utils/helpers'

export type TFetchFnParams = TStoreCategoriesProps
export type TError = string
export type TQueryKey = [string, TStoreCategoriesProps] | string[]
export type TQueryFnOpts = UseQueryOptions<ICatalogItem[], TError, ICatalogItem[], TQueryKey>
// export type TInfiniteQueryFnOpts = UseInfiniteQueryOptions<
//     ICatalogItem[],
//     TError,
//     ICatalogItem[],
//     ICatalogItem[],
//     TQueryKey
// >

const key = 'store-categories'

/**
 * Хук API получить магазины
 */
export default function useFetchStoreCategories(params: TFetchFnParams, {
    cacheTime = 600 * 1000, // 10m
    staleTime = 600 * 1000, // 10m
    ...opts
}: TQueryFnOpts = {}) {
    const { t } = useTranslation()
    const user = useSelector(userSelectors.user)

    return useQuery([`${key}-${user.id}`, params], () => {
        return StoreService.fetchStoreCategories(params)
            .then(({ data }) => {
                return data
            })
            .catch((err) => {
                return Promise.reject(getRequestError(err) || t('update_error'))
            })
    }, {
        cacheTime,
        staleTime,
        ...opts,
    })
}
